import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { mergeRegister } from '@lexical/utils';
import { BLUR_COMMAND, COMMAND_PRIORITY_LOW, FOCUS_COMMAND } from 'lexical';
import { useEffect } from 'react';

import { useBoolean } from './useBoolean';

export const useLexicalIsFocused = () => {
    const [editor] = useLexicalComposerContext();
    const { value: isFocused, setFalse, setTrue } = useBoolean(false);

    useEffect(() => {
        return mergeRegister(
            editor.registerCommand(
                FOCUS_COMMAND,
                () => {
                    setTrue();
                    return false;
                },
                COMMAND_PRIORITY_LOW
            ),
            editor.registerCommand(
                BLUR_COMMAND,
                () => {
                    setFalse();
                    return false;
                },
                COMMAND_PRIORITY_LOW
            )
        );
    }, [editor, setFalse, setTrue]);

    return isFocused;
};
